module.exports = __webpack_public_path__ + "static/assets/4ceff500c1a77a02f69519fa1956116f.svg";